import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import StyledElements from './styles';
function Band(props) {
    const { band, children } = props;
    return (_jsxs(StyledElements.Item, { children: [_jsxs(StyledElements.Name, { children: [band.Description, _jsx(StyledElements.Note, { children: band.SubDescription })] }), children] }, `attendee-${band.Id}`));
}
export default Band;
